import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles((theme: any) => ({
    statusBadge: {
        padding: [3, 10],
        width: 'fit-content',
        margin: '0 auto',
        borderRadius: '14px',
        fontSize: '12px',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        color: '#fff',
    },
    detailsButton: {
        padding: [6, 16],
        width: 'fit-content',
        margin: '0 auto',
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        cursor: 'pointer',
        fontWeight: 600,
        borderRadius: 5,
        fontSize: '13px',
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    mono: {
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: '12px',
    },
    flag: {
        display: 'inline-block',
        padding: [1, 6],
        margin: 2,
        borderRadius: 4,
        fontSize: '11px',
        fontWeight: 600,
        border: `1px solid ${theme.palette.divider}`,
        whiteSpace: 'nowrap',
    },
    errorText: {
        maxWidth: 260,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'block',
        margin: '0 auto',
        fontSize: '12px',
    },
}));
